import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';
import { ISSUE_PRIORITY_BY_KEY } from '../../util/issueConstants';

// Small filled chip visualising an issue priority (p1..p5) in its scale color.
const IssuePriorityChip = ({ priority, showFullLabel = false, sx = {} }) => {
  const theme = useTheme();
  const config = ISSUE_PRIORITY_BY_KEY[priority];
  if (!config) return null;
  return (
    <Chip
      size='small'
      label={showFullLabel ? config.label : config.shortLabel}
      sx={{
        bgcolor: config.color,
        color: theme.palette.getContrastText(config.color),
        fontWeight: 700,
        ...sx,
      }}
    />
  );
};

export default IssuePriorityChip;
